import rankMapByProximityToEnemy from './rankMapByProximityToEnemy.js';
import collectAgentCandidates from './collectAgentCandidates.js';
import findCommandForAgentUnit from './findCommandForAgentUnit.js';
const preventDefeatStrategyFactory = (scenario, mapHexes, agentSide, hexProperties, rules) => {
    return {
        name: 'preventDefeatStrategy',
        getMoveOrder: (gameState) => {
            let otherSideVps = gameState.victoryPoints.find((vp) => vp.side !== agentSide)?.points ?? 0;
            if (otherSideVps !== scenario.victoryConditions - 1) {
                return null;
            }
            const agentUnits = gameState.units.filter((unit) => unit.side === agentSide);
            const agentCandidates = collectAgentCandidates(agentSide, gameState.units, mapHexes, hexProperties, rules);
            if (!agentCandidates.length) {
                return null;
            }
            const dangerousEnemyUnitsById = {};
            const agentUnitsInDanger = {};
            agentCandidates.forEach((candidate) => {
                dangerousEnemyUnitsById[candidate.enemyUnit.id] = candidate.enemyUnit;
                agentUnitsInDanger[candidate.agentUnit.id] = candidate.agentUnit;
            });
            const dangerousEnemyUnits = Object.values(dangerousEnemyUnitsById);
            const rankedPositionsById = rankMapByProximityToEnemy({
                dangerousEnemyUnits,
                gameState,
                agentSide,
                hexes: mapHexes,
                hexProperties,
                rules,
            });
            const rankedPositions = Object.values(rankedPositionsById);
            // foreach agentCandidates
            for (const agentUnit of Object.values(agentUnitsInDanger)) {
                const command = findCommandForAgentUnit(agentUnit, rankedPositions, rankedPositionsById, hexProperties, gameState, rules, mapHexes, agentUnits, agentUnitsInDanger);
                if (command) {
                    return command;
                }
            }
            return null;
        },
    };
};
export default preventDefeatStrategyFactory;
